import React from "react";
import { UrlObject } from "url";
// @ts-ignore
import { withRouter } from "next/router";
import { stringify } from "qs";
import { compose } from "redux";
// @ts-ignore
import { doesRouteMatchWith } from "../routes";
import { useT } from "../helpers/useT";
import { NavLinkProps } from "./NavLink";

function URLObjectToString(link: UrlObject): string {
  return `${link.pathname || ""}${stringify(link.query || {}, {
    addQueryPrefix: true,
  })}`;
}

export function NavLinkOption({
  isSelectedMatchers,
  labelId,
  link,
  router,
}: NavLinkProps) {
  const t = useT();
  if (!router) {
    return null;
  }
  const isSelected = doesRouteMatchWith(router, isSelectedMatchers);
  return (
    <option
      selected={isSelected}
      value={URLObjectToString(link.href)}
      data-as={URLObjectToString(link.as)}
    >
      {t(labelId)}
    </option>
  );
}

export default compose(withRouter)(NavLinkOption);
